const fadeinDirective = {
  mounted(el: any, binding: any) {
    // 合并配置参数
    const config = {
      duration: 1200,
      delay: 0,
      distance: 20,
      easing: 'ease-out',
      once: false,
      ...(binding.value || {}),
    };

    // 设置初始状态
    el.style.opacity = '0';
    el.style.transform = `translateY(${config.distance}px)`;
    el.style.transition = `
        opacity ${config.duration}ms ${config.easing} ${config.delay}ms,
        transform ${config.duration}ms ${config.easing} ${config.delay}ms
      `;

    // 创建观察器
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // 触发动画
            requestAnimationFrame(() => {
              el.style.opacity = '1';
              el.style.transform = 'translateY(0)';
            });

            // 单次执行时解除观察
            if (config.once) {
              observer.unobserve(el);
            }
          }
        });
      },
      {
        rootMargin: '0px',
        threshold: 0.1,
      },
    );

    // 开始观察
    observer.observe(el);

    // 保存观察器实例
    el._scrollObserver = observer;
  },

  beforeUnmount(el: any) {
    // 清理观察器
    if (el._scrollObserver) {
      el._scrollObserver.disconnect();
    }
  },
};

export default fadeinDirective;
